module.exports = __webpack_public_path__ + "img/Jordan.1c66e146.png";